import Reflux from 'reflux'
import Actions from '../actions/actions'
import User from '../helpers/user'

class Store extends Reflux.Store {

    constructor() {
        super();
        this.state = {
            isGuest: User.isGuest(),
            balance: 0,
            customer: {
                hasUnporcessedInvoice: true,
                upload: {
                    date: {
                        start: null,
                        end: null,
                    },
                    fields: [],
                    unprocessedInvoices: {},
                    processedInvoices: [],
                    file: '',
                    company: ''
                },
                assaignament: {}
            },
            bank: {
                hasUnporcessedInvoice: false,
                upload: {
                    date: {},
                    fields: [],
                    masterDataFile: '',
                    openBuyerFile: '',
                    openSupplierFile: '',
                    bankStatementFile: '',
                    unprocessedInvoices: {},
                }
            },
            supplier: {
                upload: {
                    date: {
                        start: null,
                        end: null,
                    },
                    fields: [],
                    invoices: [],
                    file: '',
                    company: '',
                    supplierRules: [],
                },
                assaignament: {}
            },
            cashRegister: {
                outputfiles: [],
            },
        };
        this.listenables = Actions;
    };

    onUploadDataSet = () => {
        User.setUploadData(this.state.customer);
    };

    onUserBalanceSet = (value) => {
        this.setState({balance: value});
    };

    onUpdateStartEndDate = (dates) => {
        let customer = this.state.customer;
        customer.upload.date.startDate = dates.start;
        customer.upload.date.endDate = dates.end;
        this.setState({customer: customer});
    };

    onSetProcessedItems = (items) => {
        let customer = this.state.customer;
        customer.upload.processedInvoices = items;
        this.setState({customer: customer});
    };

    onSetUnProcessedItems = (items) => { // todo: check is exists
        let customer = this.state.customer;
        customer.upload.unprocessedInvoices = items;
        this.setState({customer: customer});
    };

    onSetUnprocessedFlag = (flag, key) => {
        let data = this.state[key];
        data.hasUnporcessedInvoice = flag;
        this.setState({[key]: data}); // todo: check
    };

    onSetCustomerUploadData = (data) => {
        let customer = this.state.customer;
        customer.upload.fields = data.fields;
        customer.upload.date.start = data.date.start;
        customer.upload.date.end = data.date.end;
        customer.upload.file = data.file;
        customer.upload.company = data.company;
        customer.upload.unprocessedInvoices = data.unprocessedInvoices;
        customer.upload.processedInvoices = data.processedInvoices;
        this.setState({customer: customer});
    };

    onSetSupplierUploadData = (data) => {
        let supplier = this.state.supplier;
        supplier.upload.fields = data.fields;
        supplier.upload.date.start = data.date.start;
        supplier.upload.date.end = data.date.end;
        supplier.upload.company = data.company;
        supplier.upload.invoices = data.invoices;
        supplier.upload.supplierRules = data.supplierRules;
        this.setState({supplier: supplier});
    };

    onSetSupplierRules = (data) => {
        let supplier = this.state.supplier;
        supplier.upload.supplierRules = data;
        this.setState({supplier: supplier});
    };

    onSetBankUploadData = (data) => {
        let customer = this.state.supplier;
        customer.upload.fields = data.fields;
        customer.upload.date.start = data.date.start;
        customer.upload.date.end = data.date.end;
        customer.upload.masterDataFile = data.masterDataFile;
        customer.upload.openBuyerFile = data.openBuyerFile;
        customer.upload.openSupplierFile = data.openSupplierFile;
        customer.upload.bankStatementFile = data.bankStatementFile;
        customer.upload.unprocessedInvoices = data.unprocessedInvoices;
        this.setState({customer: customer});
    };

    onSetCustomerAssignmentData = (data) => {
        let customer = this.state.customer;
        customer.assaignament = data;
        this.setState({customer: customer});
    };
}

export default Store;


// WEBPACK FOOTER //
// ./src/store/store.js